/* eslint-disable */

import { useParameter, useExport } from "../../../shared";
import * as React from "react";
import { REPORT_ID } from "../constants";

export function useExportQuery(title, subtitle) {
  const exportBuilder = useExport();

  const [business] = useParameter<number>("@business-units");
  const [e_countries] = useParameter<number[]>("@e_countries");
  const [commodities] = useParameter<number[]>("@commodities");
  const [commDisplay] = useParameter<number[]>("@commodities_display");
  const [calendar] = useParameter<number[]>("@calendar");
  const [eCalendar] = useParameter<number[]>("@e_calendar");
  const [e_yield_calendar] = useParameter<number[]>("@e_yield_calendar");
  const [units] = useParameter<number[]>("@units");

  React.useEffect(() => {
    exportBuilder.set('title', title);
    exportBuilder.set('subtitle', subtitle);
    exportBuilder.set('reportDefinition', {
      reportId: exportBuilder.reportId,
      name: { 9: title },
      parameters: {
        "@business-units": business && String(business),
        "@commodities": commodities && commodities.map(String),
        "@commodities_display": commDisplay && commDisplay.map(String),
        "@calendar": calendar && calendar.map(String),
        "@e_countries": e_countries && e_countries.map(String),
        "@e_calendar": eCalendar && eCalendar.map(String),
        "@e_yield_calendar": e_yield_calendar && e_yield_calendar.map(String),
        "@units": units && units.map(String),
      }
    });
  }, [title, subtitle, exportBuilder, business, calendar, e_countries, eCalendar, e_yield_calendar, commodities, commDisplay, units]);
}
